export default __webpack_public_path__ + "static/media/clipboard-icon.660371d2.svg";